export function initReveal(manifestoEl: HTMLElement | null): void {
  const revealIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          revealIO.unobserve(e.target);
        }
      });
    },
    { threshold: 0.18, rootMargin: "0px 0px -8% 0px" },
  );

  if (manifestoEl) revealIO.observe(manifestoEl);

  document.querySelectorAll<HTMLElement>(".blueprint-row").forEach((c, i) => {
    c.style.transitionDelay = i * 0.08 + "s";
    revealIO.observe(c);
  });

  document.querySelectorAll<HTMLElement>(".catalog-row").forEach((c, i) => {
    c.style.transitionDelay = i * 0.08 + "s";
    revealIO.observe(c);
  });

  document.querySelectorAll<HTMLElement>(".tile").forEach((c, i) => {
    c.style.transitionDelay = (i % 6) * 0.06 + "s";
    revealIO.observe(c);
  });
}
